// As of writing, Firefox 81 stable (and some beta versions of Firefox 80) is the latest version and introduces severe bugs into IntersectionObserver.
// Until these bugs are resolved, delete the native IntersectionObserver objects to force the polyfill installation.
if (navigator.userAgent.toLowerCase().indexOf(`firefox`) > -1) {
  const ffMatches = navigator.userAgent.match(/firefox\/\s*(\d+)/i);
  const ffVersion = parseInt(ffMatches[1]);
  // The aforementioned IntersectionObserver bugs should be fixed in Firefox 83 (https://bugzilla.mozilla.org/show_bug.cgi?id=1667521#c1),
  // polyfill costs shouldn't be imposed on a majority of Firefox users that are on newer versions.
  if (ffVersion < 83) {
    delete window.IntersectionObserver;
    delete window.IntersectionObserverEntry;
  }
}
